

// import React from 'react';
// import { Container, Grid, Card, CardContent, Typography, Box, Button } from '@mui/material';

// const files = [
//   { title: 'Procedure 1', link: '/assets/procedure1.pdf' },
//   { title: 'Procedure 2', link: '/assets/procedure2.pdf' },
//   { title: 'Procedure 3', link: '/assets/procedure3.pdf' },
//   { title: 'Procedure 4', link: '/assets/procedure4.pdf' },
//   { title: 'Procedure 5', link: '/assets/procedure5.pdf' },
// ];

// const Procedures = () => {
//   return (
//     <Container sx={{ paddingTop: '20px' }}>
//       <Typography variant="h4" sx={{ marginBottom: '20px', textAlign: 'center', color: '#556B2F' }}>נהלים ופקודות</Typography>
      
//       {/* Buffer between hours and procedures */}
//       <Box sx={{ textAlign: 'center', margin: '20px 0', padding: '10px 0', backgroundColor: '#f5f5f5', borderRadius: '10px' }}>
//         <Typography variant="h6" sx={{ color: '#333' }}>שעות פעילות : 9 בבוקר - 5 אח"הצ</Typography>
//       </Box>

//       <Grid container spacing={2} justifyContent="center">
//         {files.map((file, index) => (
//           <Grid item xs={12} sm={6} md={2} key={index}>
//             <Card sx={{ height: '150px', display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', cursor: 'pointer', transition: '0.3s', '&:hover': { backgroundColor: '#e0e0e0' } }}>
//               <CardContent>
//                 <Typography variant="h6" sx={{ color: '#333' }}>{file.title}</Typography>
//                 <Button
//                   href={file.link}
//                   download
//                   variant="contained"
//                   color="primary"
//                   sx={{ marginTop: '10px' }}
//                 >
//                   Download
//                 </Button>
//               </CardContent>
//             </Card>
//           </Grid>
//         ))}
//       </Grid>
//     </Container>
//   );
// };

// export default Procedures;


import React, { useState, useEffect } from 'react';
import { Container, Grid, Card, CardContent, Typography, Box, Button } from '@mui/material';
import { db, collection, getDocs } from '../firebase';

const Procedures = () => {
  const [procedures, setProcedures] = useState([]);

  useEffect(() => {
    fetchProcedures();
  }, []);

  const fetchProcedures = async () => {
    const proceduresCollection = await getDocs(collection(db, 'procedures'));
    const proceduresData = proceduresCollection.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setProcedures(proceduresData);
  };

  return (
    <Container sx={{ paddingTop: '20px' }}>
      <Typography variant="h4" sx={{ marginBottom: '20px', textAlign: 'center', color: '#556B2F' }}>Nahalil Procedures</Typography>
      
      {/* Buffer between hours and procedures */}
      <Box sx={{ textAlign: 'center', margin: '20px 0', padding: '10px 0', backgroundColor: '#f5f5f5', borderRadius: '10px' }}>
        <Typography variant="h6" sx={{ color: '#333' }}>Operating Hours: 9am - 5pm</Typography>
      </Box>

      <Grid container spacing={2} justifyContent="center">
        {procedures.map((procedure, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card sx={{ padding: '20px', backgroundColor: 'background.paper', color: 'text.primary', border: '1px solid #ddd', borderRadius: '10px', overflow: 'hidden', textAlign: 'center', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', position: 'relative' }}>
              <CardContent>
                <Typography variant="h6">{procedure.name}</Typography>
                <Button href={procedure.link} download variant="contained" color="primary" sx={{ marginTop: '10px' }}>Download</Button>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default Procedures;
